import React from "react";
import { useTranslation } from "react-i18next";
import "./experience.css";
import Header from "components/Header";
import MQLogo from "assets/images/mq-logo.png";
import InfomediaLogo from "assets/images/infomedia-logo.jpg";
import UNSWLogo from "assets/images/unsw-logo.png";
import SATLogo from "assets/images/sat-logo.jpg";
import PearlerLogo from "assets/images/pearler-logo.png";
import MSALogo from "assets/images/MSALogo.png";
import IceBreakLogo from "assets/images/icebreak.svg";
import JrAcademyLogo from "assets/images/jr-academy-logo.svg";
import Footer from "components/Footer";

const Experience = () => {
  const { t } = useTranslation();

  return (
    <div>
      <Header />
      <div className="experience">
        <h1>{t("experience.pageTitle")}</h1>
        <div className="experience-component">
          <div className="experience-component-title">
            <div className="experience-component-title-text">
              <h2>{t("experience.macquarie.role")}</h2>
              <h3>{t("experience.macquarie.date")}</h3>
            </div>
            <img id="MQLogo" src={MQLogo} alt="Macquarie Group Logo" />
          </div>

          <ul>
            {t("experience.macquarie.bullets", { returnObjects: true }).map(
              (bullet, index) => (
                <li key={index}>{bullet}</li>
              )
            )}
          </ul>
        </div>

        <div className="experience-component">
          <div className="experience-component-title">
            <div className="experience-component-title-text">
              <h2>{t("experience.infomedia.role")}</h2>
              <h3>{t("experience.infomedia.date")}</h3>
            </div>
            <img id="InfomediaLogo" src={InfomediaLogo} alt="Infomedia Logo" />
          </div>

          <ul>
            {t("experience.infomedia.bullets", { returnObjects: true }).map(
              (bullet, index) => (
                <li key={index}>{bullet}</li>
              )
            )}
          </ul>
        </div>
        <div className="experience-component">
          <div className="experience-component-title">
            <div className="experience-component-title-text">
              <h2>{t("experience.unsw.role")}</h2>
              <h3>{t("experience.unsw.date")}</h3>
            </div>
            <img id="UNSWLogo" src={UNSWLogo} alt="UNSW Logo" />
          </div>

          <ul>
            {t("experience.unsw.bullets", { returnObjects: true }).map(
              (bullet, index) => (
                <li key={index}>{bullet}</li>
              )
            )}
            <li>
              {t("experience.unsw.demoLabel")}{" "}
              <a
                href="https://docs.google.com/presentation/d/18TAQidDVvtG7XdAKoTerMJjcxOCxDpHeeBO8d6hso5k/edit?
              usp=sharing">
                https://docs.google.com/presentation/d/18TAQidDVvtG7XdAKoTerMJjcxOCxDpHeeBO8d6hso5k/edit?
                usp=sharing
              </a>
            </li>
          </ul>
        </div>
        <div className="experience-component">
          <div className="experience-component-title">
            <div className="experience-component-title-text">
              <h2>{t("experience.sat.role")}</h2>
              <h3>{t("experience.sat.date")}</h3>
            </div>
            <img id="SATLogo" src={SATLogo} alt="SAT Logo" />
          </div>

          <ul>
            {t("experience.sat.bullets", { returnObjects: true }).map(
              (bullet, index) => (
                <li key={index}>{bullet}</li>
              )
            )}
          </ul>
        </div>
        <div className="experience-component">
          <div className="experience-component-title">
            <div className="experience-component-title-text">
              <h2>{t("experience.pearler.role")}</h2>
              <h3>{t("experience.pearler.date")}</h3>
            </div>
            <img id="PearlerLogo" src={PearlerLogo} alt="Pearler Logo" />
          </div>

          <ul>
            {t("experience.pearler.bullets", { returnObjects: true }).map(
              (bullet, index) => (
                <li key={index}>{bullet}</li>
              )
            )}
          </ul>
        </div>
        <div className="experience-component">
          <div className="experience-component-title">
            <div className="experience-component-title-text">
              <h2>{t("experience.msa.role")}</h2>
              <h3>{t("experience.msa.date")}</h3>
            </div>
            <img id="MSALogo" src={MSALogo} alt="MSA Logo" />
          </div>

          <ul>
            {t("experience.msa.bullets", { returnObjects: true }).map(
              (bullet, index) => (
                <li key={index}>{bullet}</li>
              )
            )}
          </ul>
        </div>
        <h1>{t("experience.otherPageTitle")}</h1>
        <div className="experience-component">
          <div className="experience-component-title">
            <div className="experience-component-title-text">
              <h2>{t("experience.icebreak.role")}</h2>
              <h3>{t("experience.icebreak.date")}</h3>
            </div>
            <img
              id="IceBreakLogo"
              src={IceBreakLogo}
              alt="Ice Break Group Logo"
            />
          </div>
          <ul>
            {t("experience.icebreak.bullets", { returnObjects: true }).map(
              (bullet, index) => (
                <li key={index}>{bullet}</li>
              )
            )}
            <li>
              {t("experience.icebreak.websiteLabel")}{" "}
              <a href="https://www.icebreakescaperoom.com/">
                https://www.icebreakescaperoom.com/
              </a>
            </li>
          </ul>
        </div>
        <div className="experience-component">
          <div className="experience-component-title">
            <div className="experience-component-title-text">
              <h2>{t("experience.goexpert.role")}</h2>
              <h3>{t("experience.goexpert.date")}</h3>
            </div>
            <img id="JrAcademyLogo" src={JrAcademyLogo} alt="JR Academy Logo" />
          </div>
          <ul>
            {t("experience.goexpert.bullets", { returnObjects: true }).map(
              (bullet, index) => (
                <li key={index}>{bullet}</li>
              )
            )}
          </ul>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Experience;
